var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _c("h2", [_vm._v("Notes")]),
      _vm._v(" "),
      _c("notes-list", {
        attrs: { notes: _vm.notes },
        on: {
          addNote: _vm.addNote,
          deleteNote: _vm.deleteNote,
          pin: (id) => {
            _vm.pinNote({ userId: _vm.talent.id, noteId: id })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }